import styled from "styled-components";

export const Container = styled("div")`
  width: 100%;
`;

export const Filters = styled("div")`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 30px;
`;
